export default __webpack_public_path__ + "static/media/015_photo.a8ccb380.jpg";